export const Url = process.env.REACT_APP_URL;
export const Url_Base = process.env.REACT_APP_URL_BASE;
export const ENV_SYSTEM = process.env.REACT_APP_SYSTEM;
export const UrlImage = process.env.REACT_APP_URL_IMAGE;
export const UrlLogout = process.env.REACT_APP_URL_POST_LOGOUT;
export const GA_TRACKING_CODE = process.env.REACT_APP_GA_TRACKING_CODE;
export const AMBIENTE = process.env.REACT_APP_AMBIENTE;
